<template>
  <div
    v-if="loading"
    class="clearfix"
  >
    <b-spinner
      class="float-right"
      label="Floated Right"
    />
  </div>
  <div v-else>
    <b-row>
      <b-col
        lg="12"
        md="12"
      >
        <app-collapse type="margin">
          <app-collapse-item
            v-if="verificarPermissao('ROLE_FUNCIONARIO_CONSULTAR')"
            title="Informações Pessoais"
          >
            <FormPersonalInfoVue />
          </app-collapse-item>

          <app-collapse-item
            v-if="verificarPermissao('ROLE_HISTORICO_TIPO_REGISTRO_CONSULTAR')"
            title="Tipo de Registro"
          >
            <FormPersonalRegistryTypeVue />
          </app-collapse-item>

          <app-collapse-item
            v-if="verificarPermissao('ROLE_HISTORICO_SITUACAO_REGISTRO_CONSULTAR')"
            title="Situação"
          >
            <FormPersonalNotesVue />
          </app-collapse-item>

          <app-collapse-item
            v-if="verificarPermissao('ROLE_FUNCIONARIO_CONSULTAR')"
            title="Dados Funcionário"
          >
            <FormEmployeeDadosVue />
          </app-collapse-item>

          <app-collapse-item
            v-if="verificarPermissao('ROLE_HISTORICO_FAIXA_CONTRIBUICAO_REGISTRO_CONSULTAR')"
            title="Faixa de Contribuição"
          >
            <FormEmployeeFaixaContribuicaoVue />
          </app-collapse-item>

          <app-collapse-item
            v-if="verificarPermissao('ROLE_DOCUMENTO_CONSULTAR')"
            title="Documentações"
          >
            <FormPersonalDocumentsVue />
          </app-collapse-item>

          <app-collapse-item
            v-if="verificarPermissao('ROLE_ENDERECO_CONSULTAR')"
            title="Endereços"
          >
            <FormPersonalEnderecosVue />
          </app-collapse-item>

          <app-collapse-item
            v-if="verificarPermissao('ROLE_FONE_CONSULTAR')"
            title="Fones"
          >
            <FormEmployeeFonesVue />
          </app-collapse-item>

          <app-collapse-item title="Assinatura">
            <FormDigitalSignatureVue
              store-name="employeesAdministrativeModule"
              object-name="fullEmployee"
              action-name="editEmployeeDadosPessoais"
              prepare-action-name="prepareToEditFullEmployee"
            />
          </app-collapse-item>
        </app-collapse>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BSpinner } from 'bootstrap-vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import { verificarPermissao } from '@/auth/utils'
import FormPersonalInfoVue from './FormEmployeeInfo.vue'
import FormPersonalDocumentsVue from './FormEmployeeDocuments.vue'
import FormPersonalNotesVue from './FormEmployeeSituation.vue'
import FormPersonalEnderecosVue from './FormEmployeeEnderecos.vue'
import FormEmployeeFonesVue from './FormEmployeeFone.vue'
import FormEmployeeDadosVue from './FormEmployeeDados.vue'
import FormPersonalRegistryTypeVue from './FormEmployeeTipoRegistro.vue'
import FormEmployeeFaixaContribuicaoVue from './FormEmployeeFaixaContribuicao.vue'
import FormDigitalSignatureVue from '../../../associantes/forms/personal/FormDigitalSignature.vue'

export default {
  components: {
    AppCollapse,
    AppCollapseItem,
    FormPersonalInfoVue,
    FormPersonalDocumentsVue,
    FormPersonalNotesVue,
    FormPersonalEnderecosVue,
    FormEmployeeFonesVue,
    FormEmployeeDadosVue,
    FormPersonalRegistryTypeVue,
    FormEmployeeFaixaContribuicaoVue,
    FormDigitalSignatureVue,
    BRow,
    BCol,
    BSpinner,
  },
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      verificarPermissao,
      collapseType: 'default',
    }
  },
}
</script>
